import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';

import { useStyles } from './hint.styles';

export const SimulatorHint: FC<{ text: string }> = ({ text }): JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const [isHidden, setIsHidden] = useState(true);
  const hintRef = useRef(null);

  useEffect(() => {
    setIsHidden(false);
  }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (hintRef.current
        && !(hintRef.current as HTMLDivElement).contains(event.target as Node)
        && !(event.target as HTMLButtonElement).classList.contains('MuiTab-root')
      ) {
        setIsHidden(true);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [hintRef]);

  return (
    <>{!isHidden && (
      <button
        aria-live="polite"
        ref={hintRef}
        className={classes.hint}
        onClick={() => setIsHidden(true)}
      >
        {intl.formatMessage(
          { id: text },
          { sup: (chunks: ReactNode) => <sup>{chunks}</sup> },
        )}
      </button>
    )}</>
  );
};
